// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountGetCaseDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountGetCaseDefaultResponse.attributeTypeMap;
    }
}
SiteAccountGetCaseDefaultResponse.discriminator = undefined;
SiteAccountGetCaseDefaultResponse.additionalProperties = false;
SiteAccountGetCaseDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetCaseResponseModel"
    },
];
//# sourceMappingURL=siteAccountGetCaseDefaultResponse.js.map